module.exports = __webpack_public_path__ + "src/img/caifang_on.6d7af047.svg";